import React from "react";
import { useLocation } from "react-router-dom";
import ESModuleSubtopic from "../ESModuleSubtopic";

const SensorsActuatorsInterfacing = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || {
    subtopics: [],
    subjectPath: "",
  };

  return (
    <ESModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Sensors and actuators interfacing"
      videos={[
        "https://www.youtube.com/embed/NucRo8o8rxY",
        "https://www.youtube.com/embed/V8ykAO_Uov8",
        "https://www.youtube.com/embed/kTtt09uX894",
      ]}
      takeaways={[]}
      questions={[
        "Discuss how actuator could be used to control various types of movements. How such movement control can be applied to design a mobile vacuum cleaner. Show the interfacing and operation with 8051",
        "List any 10 sensors and actuators with their specifications and characteristics. Write the features of PIC microcontroller?",
      ]}
      exampleVideos={[]}
    />
  );
};

export default SensorsActuatorsInterfacing;
